import React from "react";

import "../styles/main.css";

import { useNavigate } from "react-router-dom";

import {
  FaArrowUp,
} from "react-icons/fa";

const Footer = () => {
  const navigate =
    useNavigate();

  /* SCROLL TOP */
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="w-full bg-[#0A3470] text-white relative overflow-hidden mt-20">

      {/* MAIN FOOTER */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-start">

          {/* LEFT */}
          <div className="space-y-6">

            <div>

              <h3 className="text-4xl md:text-5xl font-bold leading-tight">

                ST. JOSEPH'S SCHOOL

              </h3>

              <p className="text-gray-300 mt-4 text-lg">

                Maharajganj, UP - 273303

              </p>

            </div>

          </div>

          {/* RIGHT */}
          <div>

            <h3 className="text-4xl font-bold uppercase">

              FEATURED

            </h3>

            <div className="w-28 h-1 bg-[#D4A017] rounded-full mt-4 mb-10"></div>

            <div className="grid grid-cols-2 gap-x-16 gap-y-6">

              <p
                onClick={() =>
                  navigate("/events")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Current Events
              </p>

              <p
                onClick={() =>
                  navigate("/assembly")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                School Assembly
              </p>

              <p
                onClick={() =>
                  window.location.href = "/about#principle"
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Principal Desk
              </p>

              <p
                onClick={() =>
                  navigate("/admission")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Admission Form
              </p>

              <p
                onClick={() =>
                  navigate("/news")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                News
              </p>

              <p
                onClick={() =>
                  navigate("/contact")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Contact Us
              </p>

              <p
                onClick={() =>
                  navigate("/calendar")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Social Calendar
              </p>

              <p
                onClick={() =>
                  navigate("/transport")
                }
                className="cursor-pointer text-gray-200 hover:text-[#D4A017] transition-all duration-300"
              >
                Transport
              </p>

            </div>

          </div>

        </div>

      </div>

      {/* COPYRIGHT */}
      <div className="border-t border-white/10">

        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-5 flex flex-col md:flex-row justify-between items-center gap-4">

          <p className="text-gray-300 text-sm md:text-base text-center">

            © 2026 ST. JOSEPH'S SCHOOL |
            Privacy Policy

          </p>

          <a
            href="http://www.ilakshya.in/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#D4A017] text-sm md:text-base font-semibold text-center hover:text-white transition-all duration-300"
          >
            Powered By iLakshya Total Solutions
          </a>

        </div>

      </div>

      {/* SCROLL BUTTON */}
      <button
        className="fixed bottom-8 right-6 z-50 w-14 h-14 rounded-full bg-[#0B4F9C] hover:bg-[#D4A017] text-white text-xl flex items-center justify-center shadow-2xl transition-all duration-300 hover:-translate-y-1"
        onClick={scrollToTop}
      >

        <FaArrowUp />

      </button>

    </footer>
  );
};

export default Footer;